import React from 'react';
import { Box, Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { PiCoffeeFill } from 'react-icons/pi';
import { ImFire } from 'react-icons/im';
import { GameType } from '.';

type PropTypes = {
  gameType: GameType;
  handleCasualProChange: (event: any, value: 'casual' | 'pro') => void;
};
export const ToggleCasualPro = ({
  gameType,
  handleCasualProChange,
}: PropTypes) => {
  return (
    <Stack direction={'row'} justifyContent={'center'} spacing={4} marginY={1}>
      <Box sx={{ backgroundColor: 'rgba(32,33,35,1)', borderRadius: 1 }}>
        <ToggleButtonGroup
          color="primary"
          value={gameType}
          exclusive
          onChange={handleCasualProChange}
          aria-label="Platform"
        >
          <ToggleButton
            value="casual"
            fullWidth
            sx={{
              border: 'none',
              width: 112,
              borderRadius: '8px 8px 8px 8px !important',
              ':hover': {
                borderRadius: '8px 0px 0px 8px !important',
              },
            }}
          >
            <PiCoffeeFill style={{ marginRight: 8 }} />
            Casual
          </ToggleButton>
          <ToggleButton
            value="pro"
            fullWidth
            sx={{
              border: 'none',
              width: 112,
              borderRadius: '8px 8px 8px 8px !important',
              ':hover': {
                borderRadius: '0px 8px 8px 0px !important',
              },
            }}
          >
            <ImFire style={{ marginRight: 8 }} />
            Pro
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Stack>
  );
};
